import type {
  StorefrontLinkUpdateRequestType,
  StorefrontLinkUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useStorefrontLinkUpdate = (storefrontLinkId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: StorefrontLinkUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `storefront-link/${storefrontLinkId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as StorefrontLinkUpdateResponseType,
      ),
    onSettled: (response) => {
      if (response) {
        queryClient.invalidateQueries({
          queryKey: [
            business?.id,
            ServerStateKeys.StorefrontLink,
            storefrontLinkId,
          ],
        });
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.StorefrontLink],
        });
      }
    },
  });
};
